import { Link } from "react-router-dom";
import { galleryCategories } from "@/mocks/gallery";

export default function CategoryGrid() {
  return (
    <div data-product-shop className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
      {galleryCategories.map((category) => (
        <Link
          key={category.id}
          to={`/gallery?category=${category.id}`}
          className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50"
        >
          <div className="relative h-44 w-full overflow-hidden md:h-56">
            <img
              src={category.cover}
              alt={category.name}
              title={`${category.name} - 美女图片分类`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="font-heading text-base font-semibold text-white">
              {category.name}
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-white/75">{category.desc}</p>
            <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-accent-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
              <i className="ri-image-2-line"></i>
              {category.count} 张
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}